import * as actionTypes from '../actionTypes';
import { systemPresentVersion } from '../utils/commonParameters';

const state = {
  systemVersion: systemPresentVersion,
  systemTimestamp: null,
  isMaintenance: false,
};

function systemSettingReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.SET_SYSTEM_TIMESTAMP:
      return {
        ...globalState,
        systemTimestamp: action.timestamp,
      };
    case actionTypes.SET_IS_MAINTENANCE:
      return {
        ...globalState,
        isMaintenance: action.data,
      };
    default:
      return globalState;
  }
}

export default systemSettingReducer;
